import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconName", "inDropdown", "useIconNameText", "Icon"];
import { Button } from 'foundations-components/transitional/components/Button';
import { ListItem } from 'foundations-components/transitional/components/List';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarButton = props => {
  const {
      iconName,
      inDropdown = false,
      useIconNameText = true,
      Icon
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (inDropdown) {
    return /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        size: "small",
        disabled: buttonProps.disabled,
        onClick: buttonProps.onClick,
        "data-toolbar-button": "toolbar-icon-button",
        children: useIconNameText ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: `layoutBuilder.elements.iconText.${iconName}`
        }) : props.tooltip
      })
    });
  }
  return /*#__PURE__*/_jsx(IconButton, {
    size: "small",
    disabled: buttonProps.disabled,
    onClick: buttonProps.onClick,
    placement: buttonProps.placement || 'bottom left',
    use: buttonProps.use,
    tooltip: buttonProps.tooltip,
    "data-test-id": props['data-test-id'],
    "data-toolbar-button": "toolbar-icon-button",
    "data-selenium": props['data-selenium'],
    paddingBlock: "100",
    children: /*#__PURE__*/_jsx(Icon, {
      size: "300"
    })
  });
};
export default ToolbarButton;